import { render, staticRenderFns } from "./ModernCheckoutLinkModal.vue?vue&type=template&id=dfaee46a"
import script from "./ModernCheckoutLinkModal.vue?vue&type=script&lang=js"
export * from "./ModernCheckoutLinkModal.vue?vue&type=script&lang=js"
import style0 from "./ModernCheckoutLinkModal.vue?vue&type=style&index=0&id=dfaee46a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports